import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getOccupancy } from '../services/guardService';
import { useAuth } from './AuthContext';

const OccupancyContext = createContext(null);

export function OccupancyProvider({ children }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setLoading(false);
      return;
    }
    try {
      const res = await getOccupancy();
      if (res.success) {
        setCount(res.data.count);
      }
    } catch {
      // silently fail
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
    if (!user) return;
    const interval = setInterval(refresh, 30000); // refresh every 30s
    return () => clearInterval(interval);
  }, [refresh, user]);

  return (
    <OccupancyContext.Provider value={{ count, loading, refresh }}>
      {children}
    </OccupancyContext.Provider>
  );
}

export function useOccupancy() {
  const context = useContext(OccupancyContext);
  if (!context) throw new Error('useOccupancy must be used within OccupancyProvider');
  return context;
}
